export const SET_ADDRESS = "ADDRESS/SET_ADDRESS"
export const SET_MAIN_ADDRESS = "ADDRESS/SET_MAIN_ADDRESS"